// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"47197597","100":"f06eb18e","159":"2d0b49ba","395":"aeeadc46","448":"127e034d","460":"0291e96e","766":"824dd866","821":"d3a680fb","910":"e625e4ba"}[chunkId] + ".chunk.js";
};